import styled from "styled-components";

export const Container = styled.div<{ expanded: boolean }>`
  width: 100%;
  border: solid 1px
    ${({ expanded }) =>
      !expanded ? "rgba(0, 0, 0, 0.09)" : "rgba(48, 36, 225, 0.50)"};
  border-radius: 16px;
  padding: 16px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
`;

export const Wrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
`;
